import { Fingerprint } from 'lucide-react';
import type { QmsQualitySignature } from '../../types/qms.types';
import { getQmsStatusLabel } from '../../utils/workflow';

export function QmsQualitySignaturesPanel({ signatures }: { signatures: QmsQualitySignature[] }) {
  if (signatures.length === 0) return null;

  return (
    <section className="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
      <div className="mb-3 flex items-center gap-2">
        <Fingerprint className="h-4 w-4 text-teal-700" />
        <h4 className="font-medium text-slate-900">Electronic signature manifestations</h4>
      </div>
      <div className="space-y-2">
        {signatures.map((signature) => (
          <div key={signature.id} className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="font-medium text-slate-800">
                {signature.signerName} · {signature.meaning}
              </div>
              <time className="text-xs text-slate-500" dateTime={signature.signedAt}>
                {new Date(signature.signedAt).toISOString()}
              </time>
            </div>
            <div className="mt-1 text-xs text-slate-500">
              {getQmsStatusLabel(signature.fromStatus)} → {getQmsStatusLabel(signature.toStatus)}
            </div>
            <p className="mt-1 text-slate-700">{signature.reason}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
